import styled from "styled-components";

export const Container = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	position: absolute;
	top: 0;
	right: 0;
`;

export const Text = styled.span`
	font-family: Baloo;
	font-size: 26px;
	font-weight: 400;
	line-height: 28px;
	text-align: center;
	position: absolute;
	color: #fff;
	text-transform: uppercase;
`;
